import { useEffect, useState } from "react";
import "../styles/ListGroup.css"
import { LuPlus, LuSearch, LuChevronsLeft } from "react-icons/lu";
import TeamService from "../services/TeamService";
import { APIStatus } from "../constants/constant";
import { ImSpinner9 } from "react-icons/im";
import useSignalR from "../functions/myHub";
import { getInitialsGroup, stringToColor } from "../functions/function";

const ListGroup = (props) => {
  const { setIsOpened, setIsPopup, idTeamSelected, setIdTeam, setApiError } = props;
  const [isLoading, setIsLoading] = useState(false);

  const { getTeams } = TeamService();

  const [teamList, setTeamList] = useState([])
  const [currentTeamList, setCurrentTeamList] = useState([])
  const [searchContent, setSearchContent] = useState("")


  // const message = useSignalR("http://localhost:5234/myhub");
  const signalRURL = process.env.REACT_APP_URL_BE + "/myhub" //"http://localhost:5234/myhub" // process.env.REACT_APP_URL_BE
  const message = useSignalR(signalRURL); //https://msteamtool.dev.dut.udn.vn/myhub
  useEffect(() => {
    if (
      message &&
      typeof message === "object" &&
      message.id &&
      message.name
    ) {
      const isMessageInTeamList = teamList.some(team => team.id === message.id);

      if (!isMessageInTeamList) {
        setTeamList(prev => [message, ...prev]);
        setCurrentTeamList(prev => [message, ...prev]);
      }
    } else if (message) {
      console.warn("Message SignalR không hợp lệ:", message);
    }
  }, [message]);

  const fetchTeams = async () => {
    setIsLoading(true);
    try {
      const response = await getTeams();
      if (response.status === APIStatus.success) {
        const cleanedTeams = (response.data || []).filter(
          (team) => team && typeof team === "object" && team.id && team.name
        );
        const reversedTeams = [...cleanedTeams].reverse();
        // const reversedTeams = [...cleanedTeams];
        const fetchTeams = async () => {
          setIsLoading(true);
          try {
            const response = await getTeams();
            if (response.status === APIStatus.success) {
              const cleanedTeams = (response.data || []).filter(
                (team) => team && typeof team === "object" && team.id && team.name
              );
              const reversedTeams = [...cleanedTeams].reverse();
              // const reversedTeams = [...cleanedTeams];

              setTeamList(reversedTeams);
              setCurrentTeamList(reversedTeams);
            } else {
              console.error(response.data);
            }
          } catch (error) {
            console.error("Error fetching data: ", error);
            setApiError(true);
          } finally {
            setIsLoading(false);
          }
        };
        setTeamList(reversedTeams);
        setCurrentTeamList(reversedTeams);
      } else {
        console.error(response.data);
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      setApiError(true);
    } finally {
      setIsLoading(false);
    }
  };


  const searchData = (content) => {
    const searchList = teamList.filter((team) => (
      team.name
        ?.toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        ?.includes(
          content
            ?.toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
        )
    ));
    setCurrentTeamList(searchList);
  };

  useEffect(() => {
    fetchTeams();
  }, [])
  useEffect(() => {
    fetchTeams();
  }, [])

  return (
    <div className="section-container">
      <button className="close-section" onClick={() => setIsOpened(false)}>
        <LuChevronsLeft />
      </button>
      <div className="tool-section">
        <div className="search-container">
          <LuSearch />
          <input
            type="text"
            placeholder="Search"
            value={searchContent}
            onChange={(e) => {
              setSearchContent(e.target.value);
              searchData(e.target.value);
            }}
          />
        </div>

        <button className="create-button" onClick={setIsPopup} style={{ display: "none" }}>
          <LuPlus />
          <span>Create group</span>
        </button>
      </div>
      <div className="content-section">
        {isLoading ? (
          <div className="loading-container">
            <ImSpinner9 className="spin-icon" />
          </div>
        ) : (
          <>
            {currentTeamList?.length > 0 ?
              (currentTeamList.map((team, index) => (
                <div
                  key={index}
                  className={`group-display ${team.id === idTeamSelected ? "active" : ""}`}
                  title={team.name}
                  onClick={() => {
                    setIdTeam(team.id);
                    // localStorage.setItem('idTeamSelected', team.id)
                  }}
                >
                  {team.photo ? (
                    <img
                      className="group-photo"
                      src={`data:image/png;base64,${team.photo}`}
                      alt="Error"
                    />
                  ) : (
                    <div
                      className="group-photo"
                      style={{
                        backgroundColor: stringToColor(team.name),
                        color: "var(--white-color)"
                      }}
                    >{getInitialsGroup(team.name)}</div>
                  )}

                  <span>{team.name}</span>
                </div>
              ))) : null}
          </>
        )}
      </div>
    </div >
  )
}
export default ListGroup;